import React from 'react'

import IconButton from '../../Luxkit/Button/IconButton'
import LineTimesIcon from 'components/Luxkit/Icons/line/LineTimesIcon'

interface Props extends Omit<React.ComponentProps<typeof IconButton>, 'kind' | 'children'> {
  size?: React.ComponentProps<typeof IconButton>['size'];
  variant?: React.ComponentProps<typeof IconButton>['variant'];
}

function CloseButton({ size = 'small', variant = 'dark', ...props }: Props) {
  return <IconButton
    kind="tertiary"
    aria-label="Close"
    {...props}
    data-testid="close-banner-button"
    size={size}
    variant={variant}
  >
    <LineTimesIcon />
  </IconButton>
}

export default CloseButton
